import { render, staticRenderFns } from "./OutOfOfficeManager.vue?vue&type=template&id=0808e570&scoped=true"
import script from "./OutOfOfficeManager.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808e570",
  null
  
)

export default component.exports